import { OrientationType } from 'react-native-orientation-locker';
export const VALID_ORIENTATIONS = [
    OrientationType['PORTRAIT'],
    OrientationType['PORTRAIT-UPSIDEDOWN'],
    OrientationType['LANDSCAPE-LEFT'],
    OrientationType['LANDSCAPE-RIGHT'],
];
//# sourceMappingURL=validOrientations.js.map